// No map provider should ever need to zoom more than this.
export const MAX_NATIVE_ZOOM = 21;
export const MIN_ZOOM = 1;

// Open Street Map default max native zoom.
export const OSM_MAX_NATIVE_ZOOM = 19;
